import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"
import _imports_0 from '../assets/me.webp'


const _hoisted_1 = { class: "container d-flex centered" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = ["data-aos"]
const _hoisted_4 = ["data-aos"]
const _hoisted_5 = {
  "data-aos": "zoom-in",
  class: "d-flex centered"
}

import {onMounted, ref} from 'vue';

import ContactLinks from '@/components/about/ContactLinks.vue';
import SkillCards from '@/components/about/SkillCards.vue';
import ProjectCard from '@/components/project/ProjectCard.vue';
import ExperienceList from '@/components/experience/TimelineList.vue';

import {projects} from '@/data/projects';
import store from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'AboutView',
  setup(__props) {

const loaded = ref(false);

const slicedProject = projects.slice(0, 4);

onMounted(() => {
  if (store.state.loadedScreens.includes('about')) {
    loaded.value = true;
  } else {
    store.commit('addLoadedScreen', 'about');
    loaded.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "d-flex centered fade-in-image" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "me",
          class: "image"
        })
      ], -1)),
      _createElementVNode("div", {
        "data-aos": !loaded.value ? 'fade-right' : ''
      }, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("h1", { class: "text--green hi mt-4 text-center" }, "Hi, my name is", -1),
        _createElementVNode("h2", { class: "name text-center" }, "Mohammad Karim", -1)
      ]))], 8, _hoisted_3),
      _createElementVNode("div", {
        class: "description",
        "data-aos": !loaded.value ? 'fade-up' : ''
      }, [...(_cache[1] || (_cache[1] = [
        _createElementVNode("p", null, " As a full-stack developer with over 3 years of experience, I bring a core expertise in developing robust web applications and cross-platform mobile solutions, underpinned by exceptional critical thinking skills that allow me to tackle any challenge with a proactive and solution-oriented mindset. ", -1),
        _createElementVNode("p", null, " With a Bachelor's degree from UTS, my full-stack development journey continues at Mirk following an internship. I possess a proven ability to solve complex programming challenges, demonstrated through my work on various projects and as a sole trader at Quormotion. There, I independently developed applications like Brain Twist and delivered key client solutions, including a Bulk SMS Sender to streamline customer communication and an Invoice Processor for efficiency. ", -1)
      ]))], 8, _hoisted_4),
      _createVNode(ContactLinks),
      _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "col-md-12 col-12 text-center text--green my-4" }, "What I do", -1)),
      _createVNode(SkillCards),
      _cache[5] || (_cache[5] = _createElementVNode("h2", {
        "data-aos": "zoom-in",
        class: "text-center text--green my-4"
      }, " My Projects ", -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(slicedProject), (project, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createVNode(ProjectCard, {
            title: project.title,
            description: project.description,
            links: project.links,
            "tech-stack": project.techStack,
            "image-source": project.imageSource,
            "show-image-right": project.showImageRight,
            "is-small-image": !!project.isSmallImage,
            "is-large-image": !!project.isLargeImage
          }, null, 8, ["title", "description", "links", "tech-stack", "image-source", "show-image-right", "is-small-image", "is-large-image"])
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, {
          to: "/projects",
          class: "view-more"
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode(" View More ", -1)
          ]))]),
          _: 1
        })
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("h2", {
        "data-aos": "zoom-in",
        class: "text-center text--green my-4"
      }, " My Experience ", -1)),
      _createVNode(ExperienceList)
    ])
  ]))
}
}

})